<template>
    <div class="flex-grid">
        <div class="flex-xl-6">
            <p>
                Nossa paleta de cores tem o objetivo de ressaltar nossa ligação com o Brasil,
                sobretudo Minas Gerais. Por isso, optamos por tons quentes e terrosos, com o azul
                entrando como cor complementar. O laranja é a nossa cor principal, aparecendo com
                maior frequência e destaque nos materiais. Em todas elas é possível notar um chamado
                à alegria, à festividade e à diversidade.
            </p>
        </div>
        <div class="flex-xl-6">
            <picture class="w-full">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/site/2021/brand-book/cores/2021_Chico_Rei_cores.png?auto=compress,format&q=65&w=1000`"
                    alt="Paleta"
                    class="img-responsive"
                />
            </picture>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookColors',
    };
</script>
